import { ReactNode } from "react";
import { Text, Typography } from "@xcorejs/ui";

interface CopyrightProps {
  children: ReactNode;
}

const Copyright = ({ children }: CopyrightProps) => (
  <Typography variant="p">
    &copy; {new Date().getFullYear()}{" "}
    <Text color="white" fontWeight={600} display="inline-block" as="span">
      {children}
    </Text>
  </Typography>
);

export default Copyright;
